import Component from './Component';
// import Form from './Form';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

 let newForm;
 let articleLink;
 let selectData = new Map();
 let requiredFields = [];



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */

function searchMap (maps, mapData) {
    let ctaLink;
    for (let i = 0; i < maps.length; i++) {
        if (maps[i].map[0] == mapData.get(0) && maps[i].map[1] == mapData.get(1)) {
            ctaLink = maps[i].target_link;
            return ctaLink;
        }
    }
}







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Cta extends Component {

    decorator () {
        return {
            selector : '.js-cta',
            name : 'Cta',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        // BIND ELEMENTS
        this.bindElements();
    }


    cacheElements () {
        this.$form = this.element.querySelector('form');
        this.$formElements = this.$form.elements;
        this.$button = this.element.querySelector('.js-cta-btn');
    }


    bindElements () {
        let CTA = this.element.getAttribute('data-cta');

        if (CTA == 'checkbox') {
            this.checkboxElements();
        } else if (CTA == 'radio') {
            this.radioMapping();
        }
    }


    checkboxElements () {
        // Get all reqiured fields
        for (let i = 0; i < this.$formElements.length; i++) {
            if (this.$formElements[i].validity.valueMissing && !this.$formElements[i].checked) {
                requiredFields.push(this.$formElements[i]);
            }
        }

        // Loop all required fields
        // Check if all required fields are checked
        for (let x = 0; x < requiredFields.length; x++) {
            requiredFields[x].addEventListener('click', e => {
                this.checkRequiredFields();
            });
        }
    }


    checkRequiredFields () {
        const URL = this.$button.getAttribute('data-href');
        const checked = [].filter.call(requiredFields, e => {
            return e.checked;
        });

        if (requiredFields.length === checked.length) {
            this.$button.removeAttribute('disabled')
            this.$button.setAttribute('href', URL);
        } else {
            if (!this.$button.hasAttribute('disabled')) {
                this.$button.setAttribute('disabled', '')
                this.$button.setAttribute('href', 'javascript:;')
            }
        }
    }



    radioMapping () {
        this.fieldset = Array.from(this.$form.querySelectorAll('fieldset'));
        this.mapArray = this.$form.getAttribute('data-mapping');

        const mapArray = JSON.parse(this.mapArray);
        const defaultLink = this.$button.getAttribute('data-href')
        let radios = [];

        // disable button by default
        this.$button.setAttribute('disabled', '');


        for (let i = 0; i < this.fieldset.length; i++) {
            radios = this.fieldset[i].elements;

            for (let x = 0; x < radios.length; x++) {
                radios[x].addEventListener('click', e => {
                    selectData.set(i, x);

                    let articleLink = searchMap(mapArray, selectData);

                    if (typeof articleLink == 'undefined') {
                        articleLink = defaultLink;
                    }

                    // enable button
                    this.$button.removeAttribute('disabled');
                    // set button href
                    this.$button.setAttribute('href', articleLink);
                });
            }
        }
    }
}
